





















































































import { Component, Vue } from 'vue-property-decorator';
import { getRole } from '@/utils/cookie';
import { UserRole } from '@/resource/user/user.model';
import { VueGoodTable } from 'vue-good-table';
import 'vue-good-table/dist/vue-good-table.css';
import {
  getAllSubjectsDetails,
  SubjectDetails,
  getUsersCount,
} from '@/utils/add-question/add-question-util';
import LoadingBox from '@/components/common/LoadingBox.vue';

@Component({
  components: { VueGoodTable, LoadingBox },
})
export default class Dashboard extends Vue {
  columns = [
    {
      label: 'Subject',
      field: 'name',
    },
    {
      label: 'total draft',
      field: 'totalDraft',
    },
    {
      label: 'total publish',
      field: 'totalPublish',
    },
    {
      label: 'total public',
      field: 'totalPublic',
    },
    {
      label: 'total private',
      field: 'totalPrivate',
    },
    {
      label: 'total chapters',
      field: 'totalChapters',
    },
    {
      label: 'View',
      field: 'uuid',
    },
    {
      label: 'Questions',
      field: 'uuid',
    },
  ];

  totalUsers = 0;
  rows: SubjectDetails[] = [];

  total = this.rows.length;
  isLoading = true;

  get userRole(): UserRole | null {
    return getRole();
  }

  onSearch(params: any) {
    this.total = params.rowCount;
  }

  async created() {
    await this.getTotalUsers();
    await this.fetchSubjects();
  }

  async getTotalUsers() {
    const userCounts = await getUsersCount();

    if (userCounts) {
      this.totalUsers = userCounts;
    }
  }

  async fetchSubjects() {
    this.isLoading = true;
    const subjects = await getAllSubjectsDetails();

    if (subjects && subjects.length) {
      this.rows = subjects;
      this.total = this.rows.length;
    }
    this.isLoading = false;
  }

  createObjective() {
    this.$router.push({
      name: 'question-editor',
      query: {
        'is-subjective': 'false',
        'is-admin': 'true',
      },
    });
  }

  createSubjective() {
    this.$router.push({
      name: 'question-editor',
      query: {
        'is-subjective': 'true',
        'is-admin': 'true',
      },
    });
  }
}
